import React from 'react';
import { observer } from 'mobx-react';
import { Animate, Flex, InfoBanner } from 'component-library';
import { useTaxCreditsStores } from 'stores/useStores';

export const RedemptionStatusBanner = observer(() => {
  const { form8974 } = useTaxCreditsStores();

  const renderInfoBanner = () => {
    // TODO: Move the "Set up redemption" CTA and rendering logic from the CreditBalanceCard to this component.
    // if (form8974.redemptionSetupRequired) {
    //   return (
    //     <InfoBanner
    //       title='It’s time to redeem your credits!'
    //       subtitle={`Click the "Set up redemption" button, then file it with your payroll taxes.`}
    //       image={`${process.env.PUBLIC_URL}/images/tax-form-with-shadow.svg`}
    //     />
    //   );
    // }

    // if (form8974.payrollProviderSetupRequired) {
    //   return (
    //     <InfoBanner
    //       title='Redeem your credits!'
    //       subtitle={`Set up your redemption with your payroll provider now. Click the "Set up redemption" button to learn more.`}
    //       image={`${process.env.PUBLIC_URL}/images/tax-form-with-shadow.svg`}
    //     />
    //   );
    // }

    if (
      !form8974.redemptionSetupRequired &&
      !form8974.payrollProviderSetupRequired &&
      form8974.redemptionActionsInProgress
    ) {
      return (
        <InfoBanner
          title='Redeem your credits to lower your payroll taxes'
          subtitle={`You will be able to redeem more payroll tax credits next quarter. Don't worry, we'll notify you via email when it’s time!`}
          image={`${process.env.PUBLIC_URL}/images/tax-form-with-shadow.svg`}
        />
      );
    }

    return <></>;
  };

  return (
    <Animate enter={'fade-in'}>
      <Flex padding={[0, 0, 24, 0]}>{renderInfoBanner()}</Flex>
    </Animate>
  );
});
